<template>
  <div class="order">
    <div class="mt-5 pt-3">
      <h1>Order</h1>
    </div>
    <snackbar :text="text" v-if="text"/>

    <v-container style="max-width: 85%" class="mt-3">
      <waiting v-if="loading"/>
      <order-pop v-if="success" @closePop="success = $event"/>
      <v-card class="mb-5">
        <tabs :active="0" :tabs="orderTabs"></tabs>
      </v-card>

      <v-card>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-chip class="title green white--text pa-2" label style="position: absolute; left: 35px; top: -20px">Order Detail</v-chip>
               <v-layout wrap fill-height class="mb-3">
                <v-flex xs12 sm12 md6 lg6>
                  <v-text-field
                    solo
                    v-model="inputOrder.order_number"
                    color="green"
                    :rules="orderRules"
                    label="Order Number"
                    required
                  ></v-text-field>

                  <v-autocomplete
                    solo
                    v-model="inputOrder.sku_voucher"
                    color="green"
                    :items="skus"
                    item-text="sku_name"
                    item-value="sku"
                    return-object
                    :rules="[v => !!v || 'SKU is required']"
                    label="SKU Nominal"
                  ></v-autocomplete>

                  <v-text-field
                    solo
                    v-model="inputOrder.quantity"
                    color="green"
                    :rules="qtyRules"
                    label="Quantity"
                    type="number"
                    min="1"
                    required
                  ></v-text-field>

                  <v-radio-group
                    v-if="isShowMultipleLinkField"
                    v-model="inputOrder.need_multiple_link"
                    row
                    :hide-details="true"
                    >
                    <div class="d-flex justify-center hovertext" data-hover="Multiple Link merupakan mekanisme untuk menentukan hasil generate link yang dihasilkan oleh sistem. Ketika memilih 'Yes' berarti hasil link yang di hasilkan adalah 1 link 1 quantity, tetapi ketika memilih 'No' berarti hasil link yang dihasilan akan di bundling dimana ketika membeli 10 quantity akan hanya menghasilkan 1 link.">
                      <label class="mr-1">Multiple Link</label>
                      <v-icon small class="mr-2" color="black">mdi-information-outline</v-icon>
                    </div>
                      <v-radio
                        label="YES"
                        value="YES"
                        color="#4dbd77"
                      ></v-radio>
                      <v-radio
                        label="NO"
                        value="NO"
                        color="#4dbd77"
                      ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex xs12 sm12 md6 lg6>
                  <v-text-field
                    solo
                    v-model="inputOrder.receiver_name"
                    :counter="25"
                    :rules="nameRules"
                    label="Name"
                    required
                  ></v-text-field>

                  <v-text-field
                    solo
                    v-model="inputOrder.receiver_email"
                    :rules="emailRules"
                    label="Email"
                    required
                  ></v-text-field>

                  <v-text-field
                    solo
                    v-model="inputOrder.receiver_phone"
                    :counter="15"
                    :rules="phoneRules"
                    label="Phone Number"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4>
                  <div class="text-xs-left pt-2" style="height: 100px">
                    <p>
                      <span class="fw-6">Distributor Price : </span>
                      <span class="ml-2">{{ inputOrder.sku_voucher ? 'Rp ' + currency(inputOrder.sku_voucher.distributor_price) : '-' }}</span>
                      </p>
                    <p>
                      <span class="fw-6">Total Price : </span>
                      <span class="ml-2">{{ inputOrder.sku_voucher && inputOrder.quantity ? 'Rp ' + currency(Number(inputOrder.sku_voucher.distributor_price) * inputOrder.quantity) : '-' }}</span>
                      </p>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4>
                  <Captcha
                    v-if="appMode !== 'development'"
                    class="mt-2"
                    :rules="'You must agree to continue'"
                    :verified="inputOrder.checkbox"
                    :status="statCheckbox"
                    @verify="inputOrder.checkbox = $event"/>
                </v-flex>
              </v-layout>
            </v-container>

            <v-btn
              :disabled="isCreateOrderDisabled"
              class="green white--text"
              @click="sendOpenOrder"
            >
              Create Order
            </v-btn>

          </v-form>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from '@/helpers/axios'
import { signature } from '@/helpers/signature'
import { currency } from '@/helpers/currency'
import Captcha from '@/components/Captcha.vue'
import OrderPop from '@/components/OrderPop'
import Snackbar from '@/components/Snackbar.vue'
import Waiting from '@/components/Waiting'
import Tabs from '@/components/v2/Tabs'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'order',
  components: {
    Snackbar,
    Waiting,
    OrderPop,
    Captcha,
    Tabs
  },
  data () {
    return {
      success: null,
      defaultOrder: {
        reqId: `ReqId-${new Date().getTime()}-PO-${Math.floor(Math.random() * (new Date().getTime()) + 1)}`,
        order_number: '',
        sku_voucher: null,
        quantity: 1,
        receiver_name: '',
        receiver_email: '',
        receiver_phone: '',
        checkbox: null
      },
      inputOrder: {
        reqId: `ReqId-${new Date().getTime()}-PO-${Math.floor(Math.random() * (new Date().getTime()) + 1)}`,
        order_number: '',
        sku_voucher: null,
        quantity: 1,
        receiver_name: '',
        receiver_email: '',
        receiver_phone: '',
        checkbox: null,
        need_multiple_link: ''
      },
      reqId: `ReqId-${new Date().getTime()}-PO-${Math.floor(Math.random() * (new Date().getTime()) + 1)}`,
      order_number: '',
      orderRules: [
        v => !!v || 'Order number is required',
        v => (v && v.length >= 6) || 'Minimum order number is 6 characters',
        v => /^[\w-]+$/.test(v) || 'Invalid character'
      ],
      sku_voucher: null,
      skus: [],
      quantity: '',
      qtyRules: [
        v => !!v || 'Quantity is required',
        v => /^[\d]+$/.test(v) || 'Quantity must be number',
        v => (v && v > 0) || 'Quantity must be greater than zero'
      ],
      receiver_name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 25) || 'Name must be less than 25 characters',
        v => /^[\w\-\s]+$/.test(v) || 'Name must be alphanumeric'
      ],
      receiver_email: '',
      emailRules: [
        v => !!v || 'Email is required',
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Email must be valid'
      ],
      receiver_phone: '',
      phoneRules: [
        v => !!v || 'Phone number is required',
        v => /^[\d]+$/.test(v) || 'Phone number must be number',
        v => (v && v.length <= 15) || 'Phone number must be less than or equal to 15 characters',
        v => (v && v.length > 8) || 'Phone number must be more than 8 characters'
      ],
      text: null,
      valid: true,
      statCheckbox: true,
      loading: false,
      search: null,
      isShowMultipleLinkField: false
    }
  },
  methods: {
    currency: currency,
    ...mapActions([
      'getTransDefault'
    ]),
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    getSKUs () {
      let url = `/sku?app_id=${this.appid}&app_key=${this.appkey}&accesstoken=${this.token}&brandcode=`
      axios.get(url)
        .then(response => {
          let dataSKU = response.data.data
          let filterSKU = dataSKU.filter(el => el.product_status !== 'tidak-aktif') // filter sku aktif
          this.skus = filterSKU
        })
        .catch(error => {
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
        })
    },
    sendOpenOrder () {
      this.loading = true
      this.validate()

      let dataBody = {
        request_id: this.inputOrder.reqId,
        order_number: this.inputOrder.order_number,
        sku: this.inputOrder.sku_voucher ? this.inputOrder.sku_voucher.sku : '',
        qty: this.inputOrder.quantity,
        receiver_name: this.inputOrder.receiver_name,
        receiver_email: this.inputOrder.receiver_email,
        receiver_phone: this.inputOrder.receiver_phone,
        need_multiple_link: this.inputOrder.need_multiple_link ? this.inputOrder.need_multiple_link : 'NO'
      }

      let reqSignature = signature(dataBody, 'sendOpenOrder')
      axios.defaults.headers = {
        accessToken: this.token,
        milliseconds: this.expired,
        signature: reqSignature
      }

      let url = '/openOrder'

      // If in development mode, skip the captcha verification
      if (this.appMode === 'development') {
        this.inputOrder.checkbox = true
      }

      if (this.inputOrder.checkbox) {
        this.statCheckbox = true

        axios.post(url, dataBody)
          .then(response => {
            if (response.data.status !== 200) {
              this.text = response.data.message
              this.success = false
            } else {
              this.success = true
              this.reset()
              this.inputOrder = Object.assign({}, this.defaultOrder)
              this.statCheckbox = true
              this.inputOrder.checkbox = null
              this.getTransDefault()
            }
          })
          .catch(error => {
            if (error.response.data.code === 'TOE001') {
              this.$store.dispatch('refresh')
            }
            if (error.response.data.code === 'TOE002') {
              this.$store.dispatch('clear')
            }
            this.text = error.response.data.message
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.statCheckbox = false
        this.loading = false
      }
    }
  },
  computed: {
    ...mapState([
      'appid',
      'appkey',
      'token',
      'expired',
      'transDefault',
      'orderTabs'
    ]),
    appMode () {
      return process.env.VUE_APP_MODE
    },
    isCreateOrderDisabled () {
      return !this.inputOrder.sku_voucher || !this.inputOrder.need_multiple_link || !this.inputOrder.order_number || !this.inputOrder.quantity || !this.inputOrder.receiver_email || !this.inputOrder.receiver_name || !this.inputOrder.receiver_phone
    }
  },
  watch: {
    text () {
      setTimeout(() => {
        this.text = null
      }, 5000)
    },
    'inputOrder.sku_voucher' (val) {
      if (val.order_destination === 'Jatis') {
        this.isShowMultipleLinkField = true
        this.inputOrder.need_multiple_link = ''
      } else {
        this.isShowMultipleLinkField = false
        this.inputOrder.need_multiple_link = 'NO'
      }
    }
  },
  mounted () {
    this.getSKUs()
  }
}
</script>

<style scoped>
.green {
  background: #27bb8b!important;
}
.green--text {
  color: #4dbd99!important;
  border-color: #4dbd99 !important;
}
.fw-6 {
  font-weight: 600;
}

.hovertext {
  position: relative;
  /* border-bottom: 1px dotted black; */
}

.hovertext:before {
  content: attr(data-hover);
  visibility: hidden;
  opacity: 0;
  width: 450px;
  background-color: #50596c;
  color: #fff;
  text-align: left;
  border-radius: 5px;
  padding: 10px;
  font-size: 12px;
  transition: opacity 1s ease-in-out;

  position: absolute;
  z-index: 1;
  left: 0;
  top: 110%;
}

.hovertext:hover:before {
  opacity: 1;
  visibility: visible;
}
</style>
